import { Component, OnInit } from '@angular/core';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { ToastrService } from 'ngx-toastr';
import { AuthloginService } from 'src/app/services/login/authlogin.service';

@Component({
  selector: 'app-dynamicindicator',
  templateUrl: './dynamicindicator.component.html',
  styleUrls: ['./dynamicindicator.component.css']
})
export class DynamicindicatorComponent implements OnInit {
  activesidetab;
  activeSpinner : boolean;
  yearDropDownList = [];
  stateDropDownList = [];
  datasubmit = 'statewise';
  selectedstate : any;
  themeList = [];
  assessmentYear;
  themefilterlist = {};
  addButtonClick : boolean = false;
  subIndicatorList = [{serialNo:'',label:'',inputType:null}];
  indicatorfilterlist=  {};
  dropdownSettings: any = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    noDataAvailablePlaceholderText: 'No locations available.',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  validation: boolean[] = new Array(8).fill(true);
  districtflag: boolean;
  selectionList = [];
  changeFunction: number;
  datasubmitted = 'districtwise';
  subIndicatorlist: any=[];
  stateArrayList: any[];
  statelists: any[];
  constructor(private submitdataservice : SubmitdataService,
    private constants : ConstantsModule,
    private utils : UtilsModule,
    private toastr : ToastrService,
    private lognsrv : AuthloginService) { }

  ngOnInit() {
    this.submitdataservice.getStatusOfToken();
    this.navtabclick("addtheme");
    if(this.activesidetab == 'addtheme'){
      this.getstateslist();
    }
  }
  navtabclick(type){
    this.activesidetab = type;
    this.addDefalutparams()
  }
  addDefalutparams(){
    if(this.activesidetab == 'addtheme'){
      this.themefilterlist = {'srno':null,'themename':null,'stateuuidlist' : []};
    } else {
      this.indicatorfilterlist = {'themeid':null,serialnumber:null,numberInput : null,booleanInput : null,subindnumber:null,subindboolean:null,indicatorname:null,yearbased:null,SubIndicator:null,dateformat:null,NuemaratorLabel:null, DenominatorLabel:null,computationid:null,NumorDenbased:null}
    }
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }
    this.submitdataservice.getYearsToDisplay(this.submitdataservice.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    });    this.assessmentYear = dropDownYear;
    this.addIndicatorfilter();
    if(this.activesidetab != "addtheme"){
      this.getIndicatorHierarchy();
    // } else {
    //   this.getLocationList();
    }
  }
  getLocationList(){
    let option = {};
    this.stateDropDownList = [];
    option['pType'] = this.constants.LOCATION_CONSTANT['REGION'];
    option['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    // option['puuid'] = this.constants['COUNTRYUUID']
    // option['type'] = type;
    option["component"] = "";
    option["src"] = "";
    this.activeSpinner = true;
    this.submitdataservice.getLocationList(option).subscribe(data =>{
      if(data){
        // var data = this.submitdataService.getLocationList();
        let statearray = [];
        Object.keys(data).forEach((key) => {
          data[key].forEach(list => {
            statearray.push(list);
            this.stateDropDownList = this.formatListForMultiDropDown(statearray);
          });
        });
        // this.stateDropDownList.sort(this.submitdataservice.sortStates("name"))
      }
      else
       this.stateDropDownList = [];
      this.activeSpinner = false;
    },function(err){
        this.activeSpinner = false;
        if(err['error']){
          this.toastr.error(err['error']['msg'])
        }
      });
  }
  getstateslist(){
    let postdata = {};
    this.stateArrayList = [];
    this.statelists = [];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataservice.getLocationList(postdata).subscribe(data =>{
      if(data){
         this.statelists = [];
           Object.keys(data).forEach(key =>{
          data[key].forEach(statelist => {
            this.stateArrayList.push(statelist);
            this.stateArrayList.sort((a, b) => (a.name > b.name) ? 1 : -1);
            // this.filterDropDownLists['GroupList'] = this.groupListForMultiDropDown(this.statelists,true);
  
          });
        })
      }
    })
  
  }

  changeSubIndi(subIndi){
    if(subIndi == 'no'){
      // this.subIndicatorList[0]['serialNo'] = "";
      // this.subIndicatorList[0]['inputType'] = null;
      // this.subIndicatorList[0]['label'] = "";
      this.subIndicatorList = [{serialNo:'',label:'',inputType:null}];
    }
  }

  addSubIndTextBox(){
    this.subIndicatorList.push({serialNo:'',label:'',inputType:null});
  }
  inputTypeSelect(e,i){
    this.subIndicatorList[i]['inputType'] = e.target.value;
  }
  removeSubIndTextBox(){
    this.subIndicatorList.pop();
  }
  formatListForMultiDropDown(data:any): any{
    let result = [];
      for(let i = 0; i < data.length; i++){
        if(!data[i]) continue;
        let item = {};
        item['item_id'] = data[i]['uuid'];//id++;
        item['item_text'] = data[i]['name'];
        result.push(item);
      }
      result.sort((a, b) => (a.item_text > b.item_text) ? 1 : -1);
    return result;
  }
  onItemSelect(item: any) {
    this.addItem(item,'');
  }
  onItemDeSelect(item: any) {
    this.removeItem(item,'');
  }
  onItemDeSelectAll(items: any) {
    this.removeItem(items,'all');
  }
  onSelectAll(items: any) {
    this.addItem(items,'all');
  }
  addItem(item,option){
    if(option == 'all'){
     this.themefilterlist['stateuuidlist'] = [];
    }
    for(let i=0; i<item.length;i++){
      this.themefilterlist['stateuuidlist'].push(item[i]);
    }
  }
  removeItem(item,option){
    if(option == 'all'){
      this.themefilterlist['stateuuidlist'] = [];
     }else{
    for(let i=0; i<this.themefilterlist['stateuuidlist'].length;i++){
      for(let j=0; j<item.length;j++){
       if(this.themefilterlist['stateuuidlist'][i]['item_id'] == item[j]['item_id']){
        this.themefilterlist['stateuuidlist'].splice(i, 1)
       }
      }
    }
  }
  }
  computationCode(event:Event) : void { let index:number = event.target["selectedIndex"] - 1;
  this.changeFunction = index;
 };
  addIndicatorfilter(){
    let options = {
      "ay" : this.assessmentYear,
      "type" : this.activesidetab == 'addtheme' ? "THEME" : "INDICATOR"
    }
    this.submitdataservice.addIndicatorfilter(options).subscribe(data =>{
      if(this.activesidetab == 'addtheme'){
        this.themefilterlist['srno'] = data['srno'];
      }
      else 
        this.indicatorfilterlist['dateFormat'] = data['dateFormat'];
        this.indicatorfilterlist['computation'] = data['computation'];
        Object.entries(this.indicatorfilterlist['computation'] ).forEach(([key,value]) =>{
           this.selectionList.push(JSON.parse(JSON.stringify(value['FORMULA'])))
          }); 
    });
  }
  typechanged(){
    if(this.datasubmit == 'statewise'){
     this.districtflag = false;
    } else  {
      this.districtflag = true;
    }
  }
  dataSubmissionChange(){
  }
  addtheme(){
      this.activeSpinner = true;
      let postdata = this.getParameters();
      this.submitdataservice.addthemesForNmcg(postdata).subscribe(data=>{
        if(data.status){
          if(data.msg=='Internal Server error'){
            this.toastr.error('Please enter required fields');
          }
          else{
            this.toastr.success(data.msg);
            this.addDefalutparams();
          }
        } else if(data.statuscode == 420){
          this.lognsrv.logoutuserandsessionclear();
        }
         else {
          this.toastr.error(data.msg);
        }
        this.activeSpinner = false;
      });
    }

  // getparameters(){
  //   let options = {};
  //   if(this.activesidetab == 'addtheme'){
  //     options = {
  //       "serialNo" : "12",
  //       "label" : this.themefilterlist['themename'],
  //       "type" : "THEME",
  //       "view": "admin",
  //       "cType": "STATE",
  //       "ay" : this.assessmentYear,
  //       "lul" : ["bd81d570-0e97-4dad-9bcd-219a05f56f2f"]
  //     }
  //   } else {
  //     options = {
  //       "parentId" : this.indicatorfilterlist['themeid'],
  //       "ay" : this.assessmentYear,
  //       "view": "admin",
  //       "cType": this.datasubmit == 'statewise' ? this.constants.LOCATION_CONSTANT['STATE'] :this.constants.LOCATION_CONSTANT['DISTRICT'],
  //       "type" : "INDICATOR",
  //       "serialNo" : this.indicatorfilterlist['serialnumber'],
  //       "label" : this.indicatorfilterlist['indicatorname'],
  //       "lul" : null,
  //       "indicatorLocType" : "DISTRICT",
  //       "childList" : this.subIndicatorList,
  //       "inputType" : this.getInputType()
  //     }
  //   }
  //   return options;
  // }
  getParameters(){
    let postdata = {};
    if(this.activesidetab == 'addtheme'){
    postdata[ "serialNo" ] = this.themefilterlist['srno'],
    postdata["label"] = this.themefilterlist['themename'],
    postdata["type"] = "THEME",
    postdata["view"] = "admin",
    postdata["cType"] =  this.constants.LOCATION_CONSTANT['DISTRICT']
    postdata["ay"] = this.assessmentYear,
    postdata["lul"] = [this.selectedstate];
    console.log(postdata)

  } else{
    postdata['parentId'] = this.indicatorfilterlist['themeid'],
    postdata['ay'] = this.assessmentYear,
    postdata["view"] = this.constants.VIEWS['admin']
    postdata['cType'] = this.constants.LOCATION_CONSTANT['DISTRICT'],
    postdata['type'] = "INDICATOR",
    postdata['serialNo'] = this.indicatorfilterlist['serialnumber'],
    postdata['label'] = this.indicatorfilterlist['indicatorname'],
    postdata['lul'] = null;
    postdata['indicatorLocType'] = this.constants.LOCATION_CONSTANT['DISTRICT']
    postdata[ "computationId"] = this.changeFunction +1
    if(this.subIndicatorList.length == 1 && this.subIndicatorList[0]['serialNo'] == '' && this.subIndicatorList[0]['label'] == ''){
        postdata['childList'] = [];
    } else{
      postdata['childList'] = this.subIndicatorList;
    } 
    if(this.indicatorfilterlist['numberInput']){
      postdata['inputType'] = "DOUBLE";
   } else if(this.indicatorfilterlist['booleanInput']){
     postdata['inputType'] = "BOOLEAN"
   }
   if(this.indicatorfilterlist['subindnumber']){
     postdata['hasChild'] = true;
   } else if(this.indicatorfilterlist['subindboolean']){
     postdata['hasChild'] = false;
   }
  }
  return postdata
}
  getstatelist(){
    let statearray = [];
    this.themefilterlist['stateuuidlist'].forEach(list=>{
      statearray.push(list['item_id'])
    });
    return statearray;
  }
  getIndicatorHierarchy(){
    this.activeSpinner = true;
    let options = {
      "ay" : this.assessmentYear
    }
    this.submitdataservice.FetchIndicators(options).subscribe(data =>{
      data.forEach(theme => {
        if (theme.label!="Meeting at DGC ")
          this.themeList.push(theme);
        this.activeSpinner = false;
      })
    });
  }
  public basicValidation():boolean{
    if(this.activesidetab == 'addtheme'){
      this.validation[0] = this.utils.checkarrayfield(this.themefilterlist['stateuuidlist'])
      this.validation[1] = this.utils.checkfield(this.themefilterlist['themename'])
      return this.validation[0] && this.validation[1]
    }
    else {
      this.validation[2] = this.utils.checkfield(this.indicatorfilterlist['themeid']);
      this.validation[3] = this.utils.checkfield(this.datasubmit == 'statewise');
      this.validation[4] = this.utils.checkfield(this.indicatorfilterlist['serialnumber']);
      this.validation[5] = this.utils.checkfield(this.indicatorfilterlist['indicatorname'])
      this.validation[6] = this.utils.checkfield(this.indicatorfilterlist['yearbased'])
      this.validation[7] = this.indicatorfilterlist['yearbased'] == 'yes' ? this.utils.checkfield(this.indicatorfilterlist['dateformat']) : true;
      this.validation[8] = this.utils.checkfield(this.indicatorfilterlist['NumorDenbased']);
      this.validation[9] = this.indicatorfilterlist['NumorDenbased'] = 'yes'? this.utils.checkfield(this.indicatorfilterlist['NuemaratorLabel'] && this.indicatorfilterlist['DenominatorLabel']):true
      this.validation[10] = this.utils.checkfield(this.indicatorfilterlist['computationid']);
      
      return this.validation[2] && this.validation[3] && this.validation[4] && this.validation[5] && this.validation[6] && this.validation[7] && this.validation[8] && this.validation[9] && this.validation[10]
    }
  }

}
